import { render, staticRenderFns } from "./TradingVolumeRanking.vue?vue&type=template&id=0b881054&scoped=true"
import script from "./TradingVolumeRanking.vue?vue&type=script&lang=js"
export * from "./TradingVolumeRanking.vue?vue&type=script&lang=js"
import style0 from "./TradingVolumeRanking.vue?vue&type=style&index=0&id=0b881054&prod&lang=scss&scoped=true"
import style1 from "./TradingVolumeRanking.vue?vue&type=style&index=1&id=0b881054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b881054",
  null
  
)

export default component.exports